/* global axios */

import ApiClient from './ApiClient';

class R2StorageConfigAPI extends ApiClient {
  constructor() {
    super('r2_storage_config', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  update(data) {
    return axios.put(this.url, data);
  }

  delete() {
    return axios.delete(this.url);
  }
}

export default new R2StorageConfigAPI();
